import { routesMap } from "@/components/routes/routes";
import axios from "../middleware/client";
import { useAuthStore } from "@/zustand/authStore";

export function getRelationships() {
  return axios
    .get("/me/relationships")
    .then((res) => res?.data)
    .catch((error) => {
      console.error("axios error", error);
    });
}
export function getRelationshipSpecificToken(id: number) {
  return axios
    .get(`/auth/account/${id}`)
    .then((res) => res?.data)
    .catch((error) => {
      console.error("axios error", error);
      if (error.response?.status === 401) {
        if (error.response.data.message === "LICENSE_DEACTIVATED") {
          useAuthStore.getState().setLogout();
          window.location.href = routesMap.licenseDeactivated.path;
        }
      }
    });
}
export function getPermissions() {
  return axios
    .get("/me/permissions")
    .then((res) => res)
    .catch((error) => {
      console.error("axios error", error);
    });
}
export function getAvailableRoles() {
  return axios
    .get("/list-roles")
    .then((res) => res)
    .catch((error) => {
      console.error("axios error", error);
    });
}
